export const receivedNfsPtBr = {
  recreation: {
    description:
      'Gerar uma nova conta a partir desta nota fiscal? A conta anterior e seu histórico serão preservados.',
  },
  page: {
    title: 'Notas fiscais recebidas',
    subtitle: 'Listagem de documentos recebidos via Focus NFe.',
  },
  filters: {
    title: 'Filtros',
    show: 'Mostrar filtros',
    hide: 'Ocultar filtros',
    clearAll: 'Limpar filtros',
    active: 'Ativos',
    statusLabel: 'Status',
    typeLabel: 'Tipo',
    focusStatusLabel: 'Status NF',
    documentType: {
      label: 'Tipo de documento',
      placeholder: 'Selecione',
      all: 'Todos',
      nf: 'NF-e',
      nfs: 'NFS-e',
    },
    entity: {
      label: 'Entidade',
      placeholder: 'Todas',
      all: 'Todas as entidades',
    },
    issuerCnpj: {
      label: 'Emitente (CNPJ)',
      placeholder: 'Digite o CNPJ',
    },
    alchemyStatus: {
      label: 'Alquimizada?',
      placeholder: 'Selecione',
      all: 'Todas',
      pending: 'Pendente',
      transmuted: 'Transmutada',
      removed: 'Excluída',
    },
    focusStatuses: {
      label: 'Status NF',
      placeholder: 'Selecione os status',
      options: {
        authorized: 'Autorizado',
        cancelled: 'Cancelado',
        pending: 'Pendente',
        processing: 'Em processamento',
        error: 'Erro',
      },
      selectedCount: '{{count}} selecionados',
      clearSelection: 'Limpar seleção',
    },
    issueDate: {
      label: 'Data de emissão',
      placeholder: 'Selecione o período',
    },
    amount: {
      label: 'Valor total',
      placeholder: '0,00',
    },
    amountOperators: {
      eq: 'Igual a',
      gte: 'Maior ou igual a',
      lte: 'Menor ou igual a',
      eqSymbol: '=',
      gteSymbol: '≥',
      lteSymbol: '≤',
    },
    datePlaceholder: 'Selecione',
  },
  errors: {
    load: 'Falha ao carregar notas recebidas.',
    processBill: 'Falha ao enfileirar o processamento da conta a pagar.',
    recreateBill: 'Falha ao recriar a conta a pagar.',
    processAllBills: 'Falha ao enfileirar o processamento em lote.',
  },
  tabs: {
    all: 'Todos',
  },
  statuses: {
    summary: 'Resumo',
    acknowledged: 'Ciente',
    fullAvailable: 'XML disponível',
    fullNotFound: 'PDF indisponível',
    cancelled: 'Cancelado',
  },
  documentTypes: {
    nf: 'NF-e',
    nfse: 'NFS-e',
    nfseNational: 'NFS-e Nacional',
  },
  documentStatus: {
    available: 'disponível',
    cancelled: 'cancelado',
    summary: 'resumo',
  },
  table: {
    document: 'Documento',
    issuer: 'Emitente',
    entity: 'Entidade',
    type: 'Tipo',
    pdfAvailable: 'PDF Disponível?',
    alquimia: 'Processada?',
    processedTooltip:
      'Indica se a nota já gerou uma conta a pagar, ainda está pendente ou teve a conta gerada excluída.',
    status: 'Status',
    focusStatus: 'Status NF',
    issueDate: 'Emissão',
    amount: 'Valor',
    loading: 'Carregando...',
    emptyTitle: 'Nenhuma nota encontrada',
    emptyDescription: 'Aplique filtros diferentes para encontrar documentos.',
    series: 'Série {{value}}',
    actions: {
      downloadPdf: 'Baixar PDF',
      processBill: 'Processar conta a pagar',
      recreateBill: 'Recriar conta a pagar',
      processAllPendingBills: 'Processar todas pendentes',
    },
  },
  toasts: {
    processBillQueued: 'Processamento da conta a pagar enfileirado.',
    processBillAlreadyQueued: 'Processamento já está em fila ou em andamento.',
    recreateBillQueued: 'Recriação da conta a pagar enfileirada.',
    recreateBillAlreadyQueued: 'A recriação já está em fila ou em andamento.',
    processBillNotSupported: 'Processamento disponível apenas para NF-e e NFS-e Nacional.',
    processBillCancelled: 'NF cancelada não pode ser processada.',
    processAllNoCandidates: 'Nenhuma NF pendente elegível para processamento.',
    processAllQueued_one: '{{count}} processamento enfileirado.',
    processAllQueued_other: '{{count}} processamentos enfileirados.',
    processAllAlreadyQueued_one: '{{count}} NF já estava em fila.',
    processAllAlreadyQueued_other: '{{count}} NFs já estavam em fila.',
    processAllFailed_one: 'Falha em {{count}} processamento.',
    processAllFailed_other: 'Falha em {{count}} processamentos.',
  },
  alchemyStatus: {
    cancelledBill: 'Conta cancelada',
    bruta: 'Pendente',
    transmutada: 'Transmutada',
    excluida: 'Excluída',
    viewBill: 'ver conta',
    removedTooltip: 'Essa NF gerou uma conta a pagar que foi excluída',
  },
  pagination: {
    page: 'Página {{page}} de {{total}}',
    results: '{{count}} resultados',
    previous: 'Anterior',
    next: 'Próxima',
    itemsPerPageOption: '{{count}} / página',
    showing: 'Mostrando {{from}} a {{to}} de {{total}} itens',
    itemsPerPage: 'Itens por página:',
  },
} as const;

export const receivedNfsEn = {
  recreation: {
    description:
      'Create a new bill from this fiscal document? The previous bill and its history will be preserved.',
  },
  page: {
    title: 'Received fiscal documents',
    subtitle: 'Listing of documents received via Focus NFe.',
  },
  filters: {
    title: 'Filters',
    show: 'Show filters',
    hide: 'Hide filters',
    clearAll: 'Clear filters',
    active: 'Active',
    statusLabel: 'Status',
    typeLabel: 'Type',
    focusStatusLabel: 'NF Status',
    documentType: {
      label: 'Document type',
      placeholder: 'Select',
      all: 'All',
      nf: 'NF-e',
      nfs: 'NFS-e',
    },
    entity: {
      label: 'Entity',
      placeholder: 'All',
      all: 'All entities',
    },
    issuerCnpj: {
      label: 'Issuer (CNPJ)',
      placeholder: 'Enter CNPJ',
    },
    alchemyStatus: {
      label: 'Alchemized?',
      placeholder: 'Select',
      all: 'All',
      pending: 'Pending',
      transmuted: 'Transmuted',
      removed: 'Deleted',
    },
    focusStatuses: {
      label: 'NF Status',
      placeholder: 'Select statuses',
      options: {
        authorized: 'Authorized',
        cancelled: 'Cancelled',
        pending: 'Pending',
        processing: 'Processing',
        error: 'Error',
      },
      selectedCount: '{{count}} selected',
      clearSelection: 'Clear selection',
    },
    issueDate: {
      label: 'Issue date',
      placeholder: 'Select period',
    },
    amount: {
      label: 'Total amount',
      placeholder: '0.00',
    },
    amountOperators: {
      eq: 'Equals',
      gte: 'Greater than or equal to',
      lte: 'Less than or equal to',
      eqSymbol: '=',
      gteSymbol: '≥',
      lteSymbol: '≤',
    },
    datePlaceholder: 'Select',
  },
  errors: {
    load: 'Failed to load received documents.',
    processBill: 'Failed to enqueue bill processing.',
    recreateBill: 'Failed to recreate the bill.',
    processAllBills: 'Failed to enqueue bulk processing.',
  },
  tabs: {
    all: 'All',
  },
  statuses: {
    summary: 'Summary',
    acknowledged: 'Acknowledged',
    fullAvailable: 'Full available',
    fullNotFound: 'PDF not available',
    cancelled: 'Cancelled',
  },
  documentTypes: {
    nf: 'NF-e',
    nfse: 'NFS-e',
    nfseNational: 'NFS-e Nacional',
  },
  documentStatus: {
    available: 'available',
    cancelled: 'cancelled',
    summary: 'summary',
  },
  table: {
    document: 'Document',
    entity: 'Entity',
    issuer: 'Issuer',
    type: 'Type',
    pdfAvailable: 'PDF Available?',
    alquimia: 'Processed?',
    processedTooltip:
      'Shows whether this document has generated an accounts payable bill, is still pending, or had its generated bill deleted.',
    status: 'Status',
    focusStatus: 'NF Status',
    issueDate: 'Issue date',
    amount: 'Amount',
    loading: 'Loading...',
    emptyTitle: 'No documents found',
    emptyDescription: 'Try adjusting the filters to find documents.',
    series: 'Series {{value}}',
    actions: {
      downloadPdf: 'Download PDF',
      processBill: 'Process bill',
      recreateBill: 'Recreate bill',
      processAllPendingBills: 'Process all pending',
    },
  },
  toasts: {
    processBillQueued: 'Bill processing queued.',
    processBillAlreadyQueued: 'Bill processing is already queued or running.',
    recreateBillQueued: 'Bill recreation queued.',
    recreateBillAlreadyQueued: 'Bill recreation is already queued or running.',
    processBillNotSupported: 'Processing is only available for NF-e and NFS-e Nacional documents.',
    processBillCancelled: 'Cancelled documents cannot be processed.',
    processAllNoCandidates: 'No eligible pending documents found.',
    processAllQueued_one: '{{count}} processing queued.',
    processAllQueued_other: '{{count}} processings queued.',
    processAllAlreadyQueued_one: '{{count}} document was already queued.',
    processAllAlreadyQueued_other: '{{count}} documents were already queued.',
    processAllFailed_one: '{{count}} processing failed.',
    processAllFailed_other: '{{count}} processings failed.',
  },
  alchemyStatus: {
    bruta: 'Pending',
    cancelledBill: 'Bill cancelled',
    transmutada: 'Transmuted',
    excluida: 'Deleted',
    viewBill: 'view bill',
    removedTooltip: 'This NF generated an accounts payable bill that was later deleted',
  },
  pagination: {
    page: 'Page {{page}} of {{total}}',
    results: '{{count}} results',
    previous: 'Previous',
    next: 'Next',
    itemsPerPageOption: '{{count}} / page',
    showing: 'Showing {{from}} to {{to}} of {{total}} items',
    itemsPerPage: 'Items per page:',
  },
} as const;
